import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router,Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { encryptionService } from 'src/app/common-service/cedService';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { ExcutiveService } from 'src/app/excucomm/service/excutive.service';
import { constantServices } from 'src/app/griviance/models/const.model';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { OutboundService } from '../../services/outbound.service';
import { SignupService } from 'src/app/common-service/signup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelperService } from 'src/app/common-service/helper.service';


@Component({
  selector: 'app-dispatch-process-history',
  templateUrl: './dispatch-process-history.component.html',
  styleUrls: ['./dispatch-process-history.component.css']
})
export class DispatchProcessHistoryComponent implements OnInit {
  subscribe: Subject<any> = new Subject<any>();
  history: any;
  fileno: any;
  sheetDetails: any;
  NameChangingTO: boolean = false;
  dispatchId: any;
  decryptDispatchId: any;
  roleName: any;
  
  constructor(public signin: SignupService, private outboundsvc: OutboundService, private route: ActivatedRoute, public activatedRoute: ActivatedRoute,private router:Router,
    public ecConst: constantServices, public ecservice: ExcutiveService, public serverURL: ServerURLService, public usrMgtService: UsrmgtService,
    public scconst: constantServices, public ced: encryptionService, public EncrDecr: EncrDecrService, public tostar: ToastrService, public spinner: NgxSpinnerService, public helper: HelperService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => this.decryptDispatchId = params.id);
    this.dispatchId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptDispatchId);
    this.roleName=sessionStorage.getItem('selectedRole-usec');

    if(this.roleName === 'President' || this.roleName === 'Chairperson'|| this.roleName === 'Secretary' || this.roleName === 'Secretary Incharge' || this.roleName === 'Joint Secretary'  
    || this.roleName === 'AFSecInCharge' || this.roleName === 'AdmsnIncharge' || this.roleName === 'AcademicIncharge' 
    || this.roleName === 'LegalSecInCharge' || this.roleName === 'AEIncharge' || this.roleName === 'ISecInCharge' 
    || this.roleName === 'RTISecInCharge' || this.roleName === 'ServerSecInCharge' || this.roleName === 'ARPMSecInCharge' 
    || this.roleName === 'PDMSSecInCharge' || this.roleName === 'InspAsstSecty' || this.roleName === 'MSAsstSecty' 
      || this.roleName === 'ARPMAsstSecty' || this.roleName === 'AcademicAsstSecty' || this.roleName === 'AdmsnAsstSecty' || this.roleName === 'PDMSAsstSecty' 
      || this.roleName === 'AEAssistantSecretary' || this.roleName === 'PDMSSectionOfficer' || this.roleName === 'LegalSectionOfficer' || this.roleName === 'RTISectionOfficer'
      || this.roleName === 'AFSectionOfficer' || this.roleName === 'AESectionofficer' || this.roleName === 'AcademicSectionOfficer' || this.roleName === 'AdmsnSectionOfficer'
      || this.roleName === 'RTIAssistantSectionOfficer'|| this.roleName === 'ARPMAssistantSectionOfficer' || this.roleName === 'AdmsnAssistantSectionOfficer'
      || this.roleName === 'AcademicAssistantSectionOfficer' || this.roleName === 'PDMSAssistantSectionOfficer' || this.roleName === 'AFAssistantSectionOfficer' 
      || this.roleName === 'AEAssistantSectionOfficer' || this.roleName === 'LegalAssistantSectionOfficer' || this.roleName === 'LegalRetainer' || this.roleName === 'RTILegalRetainer' 
      || this.roleName === 'Accountant' || this.roleName === 'DAK_Section_Executive' || this.roleName === 'Student Admission Executive' || this.roleName === 'AcademicExecutive' 
      || this.roleName === 'ServerSecExecutive' || this.roleName === 'PDMSExecutive' || this.roleName === 'RTIExecutive' || this.roleName === 'AdmsnSecExecutive' 
      || this.roleName === 'AFExecutive' || this.roleName === 'LegalExecutive' || this.roleName === 'AEExecutive' || this.roleName === 'ARPMSecExecutive') {
        this.getProcessHistory();
      } else {      
        this.signin.deleteOauthToken().subscribe((result: any) => {      
      });
      }
  }
  
getProcessHistory() {
  this.spinner.show();
  this.outboundsvc.history(this.dispatchId).pipe(takeUntil(this.subscribe)).subscribe((res: any) => {
    this.outboundsvc.getDispatchById(this.dispatchId).pipe(takeUntil(this.subscribe)).subscribe(result => {          
      this.sheetDetails = result;
          if((this.sheetDetails?.dakStatus?.statusName === "Dispatched" || 
          this.sheetDetails?.dakStatus?.statusName === "Dispatched & Assigned") && this.sheetDetails.emailDispatchVia){
            for(let i=0; i<this.sheetDetails.dakWorkflowCommentsDTO.length ; i++){
              if(res[i].statusName==="Dispatched"){
                res[i].receiverActor="Sent Via Email";
                res[i].statusName="Email Sent";         
              }
            }
      }
      this.spinner.hide();
      this.history=res;      
    },error=>{
      this.spinner.hide();
      console.log(error);
    });       
  },error=>{
    this.spinner.hide();
    console.log(error);
    this.helper.errorMessage(error);
  });
}

  back(){
   if(this.roleName ==='ARPMSecInCharge'||this.roleName ==='PDMSSecInCharge'||this.roleName ==='AdmsnIncharge'
    ||this.roleName ==='AcademicIncharge' ||this.roleName ==='AEIncharge' ||this.roleName ==='AFSecInCharge'||this.roleName ==='LegalSecInCharge'
    ||this.roleName === 'RTISecInCharge'||this.roleName === 'ServerSecInCharge')
    this.router.navigate(['main/internal/outbound/secInch/secInchDispatchDashboard']);
    else if(this.roleName ==='Secretary' || this.roleName ==='Secretary Incharge' || this.roleName === 'Joint Secretary')
    this.router.navigate(['main/internal/outbound/CZsQVJe0x6/dispatchDashboard']);
    else if(this.roleName ==='President'|| this.roleName === 'Chairperson')
    this.router.navigate(['main/internal/outbound/president/dispatchDashboard']);
    else 
    this.router.navigate(['main/internal/outbound/se/dispatchDashboard']);
    sessionStorage.setItem("back", "back");
  }
}
